import {
    AppointmentContainer,
    HeadText,
    MainForm,
    MainInput,
    MainText,
    AppointmentButton,
    BlueSpan,
    GreenSpan,
    ErrorText,
    AppointmentWrapper,
    SuccessCard,
    SuccessIconWrap,
    SuccessTitle,
    SuccessDescription,
    SuccessButton,
} from "./styled";
import {Container} from "../Container/Container";
import {Controller, useForm} from "react-hook-form";
import axios from "axios";
import { API_URL } from "../../api/config";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {useEffect, useState} from "react";
import { CustomSelect } from "./inputs/CustomSelect";
import { CustomDatePicker } from "./inputs/CustomDatePicker";

const schema = yup.object().shape({
    fioChild: yup.string().required("Пожалуйста, введите фамилию и имя ребенка"),
    fioChildFr: yup.string().required("Пожалуйста, введите имя ребенка на французском"),
    class: yup.string().required("Пожалуйста, введите класс ребенка"),
    fullAge: yup
        .number()
        .typeError("Пожалуйста, введите количество полных лет")
        .required("Пожалуйста, введите количество полных лет")
        .positive("Возраст должен быть положительным числом")
        .integer("Возраст должен быть целым числом"),
    fioParent: yup.string().required("Пожалуйста, введите ваши Ф.И.О."),
    date: yup
        .date()
        .required("Пожалуйста, выберите дату")
        .min(new Date(2000, 0, 1), "Дата должна быть не раньше 1 января 2000 года")
        .max(new Date(), "Дата не может быть в будущем"),
    telephone: yup
        .string()
        .required("Пожалуйста, введите ваш телефон")
        .matches(/^\d+$/, "Телефон должен содержать только цифры"),
    email: yup
        .string()
        .required("Пожалуйста, введите адрес электронной почты")
        .email("Некорректный адрес электронной почты"),
});

export const Appointment = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const [success, setSuccess] = useState(false);
    const [selectedOption, setSelectedOption] = useState(false);

    const {
        register,
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    })

    const handleSendAnother = () => {
        reset();
        setSelectedOption(false);
        setSuccess(false);
    };
    const appointmentFunc = async (data: any) => {
        try{
            await axios.post(`${API_URL}/api/v1/form`, {
                childFrenchname: data.fioChildFr,
                childName: data.fioChild,
                phone: data.telephone,
                birthday: data.date,
                fullAge: data.fullAge + "",
                classSchool: data.class,
                fio: data.fioParent,
                email: data.email,
                wasCheck: selectedOption
            })
            setSuccess(true)
        }catch(error){}

    }

    const onSubmit = (data:any) => {
        appointmentFunc(data)
    }

    return <Container>
        <AppointmentContainer>
            <AppointmentWrapper>
                <HeadText>Регистрация учеников «Мечты» на 2026-2027 учебный год</HeadText>
                <MainText>Уважаемые Родители!</MainText>
                <MainText>5 апреля начианется регистрация на новый 2026-2027 учебный год</MainText>
                <MainText>Для учащихся регистрационный взнос - <BlueSpan>70$</BlueSpan></MainText>
                {/*<MainText>Детский Центр «Мечта» продолжает онлайн регистрацию на новый, <BlueSpan> 2025-2026, учебный год.</BlueSpan> С 1 июня регистрационный взнос —  <BlueSpan> 60 долларов.</BlueSpan></MainText>*/}
                <MainText>Заполните форму и оплатите регистрационный взнос.</MainText>
                <MainText>Оплата производится путём <BlueSpan> Envoyer un Virement Interac</BlueSpan> по телефону <BlueSpan> 514-772-5012 </BlueSpan>или по электронной почте: <GreenSpan> sitnikova.mechta@gmail.com</GreenSpan>
                </MainText>
                <MainText>Ответ на вопрос для электронного перевода: <BlueSpan>Mechta</BlueSpan></MainText>

                {success ? (
                    <SuccessCard>
                        <SuccessIconWrap>
                            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
                                <path
                                    d="M5 12.5L10 17.5L19 7.5"
                                    stroke="currentColor"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </SuccessIconWrap>
                        <SuccessTitle>Спасибо за заявку!</SuccessTitle>
                        <SuccessDescription>
                            Мы получили ваши данные и свяжемся с вами в ближайшее время.
                            Не забудьте оплатить регистрационный взнос, чтобы завершить запись.
                        </SuccessDescription>
                        <SuccessButton type="button" onClick={handleSendAnother}>
                            Отправить ещё одну заявку
                        </SuccessButton>
                    </SuccessCard>
                ) : (
                    <MainForm onSubmit={handleSubmit(onSubmit)}>
                        <label htmlFor="cars">Учились в школе?  </label>
                        <CustomSelect<boolean>
                            value={selectedOption}
                            onChange={setSelectedOption}
                            options={[
                                { label: 'нет', value: false },
                                { label: 'да', value: true },
                            ]}
                        />
                        <MainInput placeholder="Фамилия и имя ребенка" {...register('fioChild')}/>
                        {errors.fioChild && <ErrorText>{errors.fioChild.message}</ErrorText>}
                        <MainInput placeholder="Nom et prénom" {...register('fioChildFr')}/>
                        {errors.fioChildFr && <ErrorText>{errors.fioChildFr.message}</ErrorText>}
                        <MainInput placeholder="Класс, который он(а) посещал(а) в 2026-2027 учебном году" {...register('class')}/>
                        {errors.class && <ErrorText>{errors.class.message}</ErrorText>}
                        <MainInput placeholder="кол-во полных лет" type="number" {...register('fullAge')}/>
                        {errors.fullAge && <ErrorText>{errors.fullAge.message}</ErrorText>}
                        <label htmlFor="date">Дата рождения</label>
                        <Controller
                            name="date"
                            control={control}
                            render={({ field }) => (
                                <CustomDatePicker
                                    value={field.value ?? null}
                                    onChange={field.onChange}
                                    onBlur={field.onBlur}
                                    placeholder="Выберите дату рождения"
                                    min={new Date(2000, 0, 1)}
                                    max={new Date()}
                                />
                            )}
                        />
                        {errors.date && <ErrorText>{errors.date.message}</ErrorText>}
                        <MainInput placeholder="Ваши Ф.И.О" {...register('fioParent')}/>
                        {errors.fioParent && <ErrorText>{errors.fioParent.message}</ErrorText>}
                        <MainInput placeholder="Ваш телефон" type="number" {...register('telephone')}/>
                        {errors.telephone && <ErrorText>{errors.telephone.message}</ErrorText>}
                        <MainInput placeholder="Адрес электронной почты" type="email" {...register('email')}/>
                        {errors.email && <ErrorText>{errors.email.message}</ErrorText>}
                        <AppointmentButton type="submit">Запись</AppointmentButton>
                    </MainForm>
                )}
            </AppointmentWrapper>
        </AppointmentContainer>
    </Container>
}
